import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getMyInfoDataAction, getMyInfoDataPublicAction } from '../../../actions/myinfo';
import { RoutesPaths } from '../../../Router/constant';
import Loader from '../../../components/loader';

export default function MyinfoProcess() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleOAuthRedirect = async () => {
            console.log("here comes in process")
            const queryParams = new URLSearchParams(location.search);
            console.log("location", location);
            if (location.search) {
                const code = queryParams.get("code") || null;
                const state = queryParams.get("state") || null;
                const error = queryParams.get("error") || null;
                const errorDesc = queryParams.get("error-description") || null;
                console.log("code", code, "state", state, "error", error, "errorDesc", errorDesc);
                if ((code && state) || (error && state)) {
                    var splitState = state.split("-");
                    const identify = splitState[splitState.length - 1];
                    if (splitState.length > 0) {
                        var resp = await dispatch(getMyInfoDataPublicAction({
                            status: code ? true : false,
                            code: code ? code : null,
                            reason: errorDesc,
                            company: splitState[0],
                            errorType: error,
                        }));
                        console.log("resp", resp);
                        if (resp?.chat) {
                            navigate(RoutesPaths.MESSAGE_DETAIL_PUBLIC + "?room=" + resp.chat + "&ispublic=true", { replace: true });
                        }
                    }
                }
            }
        };

        handleOAuthRedirect();
    }, [dispatch, location]);

    return (
        <div>
            <Loader />
        </div>
    )
}
